const fndryThemeInitWrapper = () => {
   // do functions / imports here.
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );
